import { useTranslation } from "react-i18next";
import { Col, Form, MenuProps, Row, Spin, Switch, Typography } from "antd";
import { FormInstance } from "antd/lib";
import { FunctionComponent, useEffect, useState } from "react";
import FormInput from "../../../../../components/form-input/FormInput";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { get, isEmpty } from "lodash";
import { regexEmail, phoneNumberRegex, regexEmailV2 } from "../../../../../utils/regex";
import { useWatch } from "antd/es/form/Form";
import { getIndustryLecturer } from "../../../../../service/category-management/lecturer-management";
import { getAllIndustry } from "../../../../../service/course-construct";



type FormCreateLecturerProps = {
	form: FormInstance,
	onFinish?: any,
	dataOptions?: any,
	loadingForm: boolean,
}



const FormCreateLecturer: FunctionComponent<FormCreateLecturerProps> = ({ form, onFinish, dataOptions, loadingForm }) => {
  const { t } = useTranslation();

  const validations = {
	name: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (value && value.length > 512) {
				return Promise.reject(new Error(t("Tên giảng viên không vượt quá 512 ký tự", "Tên giảng viên không vượt quá 512 ký tự")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập tên giảng viên", "Vui lòng nhập tên giảng viên")))
			}
			return Promise.resolve()
		}
	},
	university: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn đơn vị công tác", "Vui lòng chọn đơn vị công tác")))
			}
			return Promise.resolve()
		}
	},
	code: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (value && value.length > 512) {
				return Promise.reject(new Error(t("Mã giảng viên không vượt quá 512 ký tự", "Mã giảng viên không vượt quá 512 ký tự")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập mã giảng viên", "Vui lòng nhập mã giảng viên")))
			}
			return Promise.resolve()
		}
	},
	gender: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn giới tính", "Vui lòng chọn giới tính")))
			}
			return Promise.resolve()
		}
	},
	phone: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!isEmpty(value) && !value.match(new RegExp(phoneNumberRegex))) {
				return Promise.reject(new Error(t("Sai định dạng, vui lòng nhập lại", "Sai định dạng, vui lòng nhập lại")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập số điện thoại", "Vui lòng nhập số điện thoại")))
			}
			return Promise.resolve()
		}
	},
	email: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!isEmpty(value) && !value.match(new RegExp(regexEmail))) {
				return Promise.reject(new Error(t("Sai định dạng, vui lòng nhập lại", "Sai định dạng, vui lòng nhập lại")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập địa chỉ email", "Vui lòng nhập địa chỉ email")))
			}
			return Promise.resolve()
		}
	},
	regency: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn chức vụ", "Vui lòng chọn chức vụ")))
			}
			return Promise.resolve()
		}
	},
	academicLevel: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn trình độ học vấn", "Vui lòng chọn trình độ học vấn")))
			}
			return Promise.resolve()
		}
	},
	domicile: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn nguyên quán", "Vui lòng chọn nguyên quán")))
			}
			return Promise.resolve()
		}
	},
	department: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value || value.length < 1) {
				return Promise.reject(new Error(t("Vui lòng chọn khoa", "Vui lòng chọn khoa")))
			}
			return Promise.resolve()
		}
	},
	specialized: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value || value.length < 1) {
				return Promise.reject(new Error(t("Vui lòng chọn chuyên ngành", "Vui lòng chọn chuyên ngành")))
			}
			return Promise.resolve()
		}
	}

}

  const gendersOptions = [
    {
      id: "Nam",
      name: t("Nam", "Nam"),
    },
    {
      id: t("Nữ", "Nữ"),
      name: t("Nữ", "Nữ"),
    },
	{
	  id: t("Khác", "Khác"),
	  name: t("Khác", "Khác"),
	},
];

	const departmentId = useWatch("department", form);
	const [dataSpecialized, setDataSpecialized] = useState<any>([]);

	const getDataSpecialized = async (departmentId: string) => {
		const getCodeDepartmentById = get(dataOptions, 'dataDepartment', '').find((item: any) => item.id === departmentId)?.id;
		try {
			await getAllIndustry([getCodeDepartmentById]).then((res) => {
				if(res.status === 200) {
					setDataSpecialized(res.data.data);
				}
			})
		} catch (err) {
			console.error(err);
		}
	}

	const handleChangeDepartment = () => {
		setDataSpecialized([]);
		form.setFieldsValue({
			specialized: [],
		});
	}

	useEffect(() => {
		if(departmentId) {
			getDataSpecialized(departmentId);
		} else {
			setDataSpecialized([]);
		}
	}, [departmentId])

    return (
        <>
            <Form layout={"vertical"} form={form} onFinish={onFinish} name="createLecturer" initialValues={{ status : true}}>
				{loadingForm ? 
					<div className="statistic-course-content statistic-course-loading">
						<Spin size="large" />
					</div> 
					: 
					<Row gutter={[16,16]}>
						<Col span={24}>
							<Form.Item name="name" rules={[validations.name]} label={t("Tên giảng viên", "Tên giảng viên")}>
								<FormInput placeholder={t("Nhập tên giảng viên", "Nhập tên giảng viên")} />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="university" rules={[validations.university]} label={t("Đơn vị công tác", "Đơn vị công tác")}>
								<FormItemDropdown options={get(dataOptions, 'dataUniversity', '')} allowClear={true} placeholder={t("Chọn đơn vị công tác", "Chọn đơn vị công tác")} />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="academicLevel" label={t("Trình độ học vấn", "Trình độ học vấn")}>
								<FormItemDropdown options={get(dataOptions, 'dataAcademicLevel', '')} allowClear={true} placeholder={t("Chọn trình độ học vấn", "Chọn trình độ học vấn")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="code"rules={[validations.code]} label={t("Mã giảng viên", "Mã giảng viên")}>
								<FormInput placeholder={t("Nhập mã giảng viên", "Nhập mã giảng viên")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="regency" label={t("Chức vụ", "Chức vụ")}>
								<FormItemDropdown options={get(dataOptions, 'dataRegency', '')} allowClear={true} placeholder={t("Chọn chức vụ", "Chọn chức vụ")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="gender" label={t("Giới tính", "Giới tính")}>
								<FormItemDropdown options={gendersOptions} placeholder={t("Chọn giới tính", "Chọn giới tính")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="domicile" label={t("Nguyên quán", "Nguyên quán")}>
								<FormItemDropdown options={get(dataOptions, 'dataProvinces', '')} allowClear={true} placeholder={t("Chọn nguyên quán", "Chọn nguyên quán")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="department" label={t("Khoa", "Khoa")}>
								<FormItemDropdown options={get(dataOptions, 'dataDepartment', '')} onChange={handleChangeDepartment} allowClear={true} placeholder={t("Chọn khoa", "Chọn khoa")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="specialized" label={t("Chuyên ngành", "Chuyên ngành")}>
								<FormItemDropdown disabled={!departmentId} modeDropdown="multiple" options={dataSpecialized} allowClear={true} placeholder={t("Chọn chuyên ngành", "Chọn chuyên ngành")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="phone" label={t("Điện thoại liên hệ", "Điện thoại liên hệ")}>
								<FormInput placeholder={t("Nhập số điện thoại", "Nhập số điện thoại")} />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="email" rules={[validations.email]} label={t("Địa chỉ Email", "Địa chỉ Email")}>
								<FormInput placeholder={t("Nhập địa chỉ email", "Nhập địa chỉ email")} />
							</Form.Item>
						</Col>
						<Col span={24} style={{display:"flex", justifyContent:"space-between"}}>
							<span>{t("Trạng thái", "Trạng thái")}</span>
							<Form.Item name="status">
								<Switch defaultChecked />
							</Form.Item>
						</Col>
					</Row>
				}
			</Form>
        </>
    )
}

export default FormCreateLecturer;